import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EventWorldModel } from './EventWorldModel';
import { SearchModel } from '../SearchModel';

@Injectable({
  providedIn: 'root'
})
export class EventWorldService {

 
  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 getAll(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}EventWorld/GetAll`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

GetAllByCountryId(countryId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}EventWorld/GetAllByCountryId/${countryId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
getById(Id:number): Observable<any> {

  return this.http
    .get<any>(`${this.baseUrl}EventWorld/GetById/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
insert(payload: EventWorldModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}EventWorld/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
GetAllByDate(payload: SearchModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}EventWorld/GetAllByDate`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
update(payload: EventWorldModel): Observable<any> {
  return this.http
    .post<any>(`${this.baseUrl}EventWorld/Update`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

delete(Id:number): Observable<any> {
  return this.http
    .get<any>(`${this.baseUrl}EventWorld/Delete/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

  deleteList(payload: EventWorldModel []): Observable<any> {
    console.log(JSON.stringify(payload))
    return this.http
      .post<any>(`${this.baseUrl}EventWorld/DeleteList`,JSON.stringify(payload),this.httpOptions)
      .pipe(catchError((error: any) => throwError(error => error)));
  }
}
